import { render, staticRenderFns } from "./DetalleEnviarNotificacion.vue?vue&type=template&id=2eb33bc6&"
import script from "./DetalleEnviarNotificacion.vue?vue&type=script&lang=js&"
export * from "./DetalleEnviarNotificacion.vue?vue&type=script&lang=js&"
import style0 from "./DetalleEnviarNotificacion.vue?vue&type=style&index=0&id=2eb33bc6&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports